"use client";

import { api } from "@agroproj/backend/convex/_generated/api";
import { useQuery } from "convex/react";
import { useParams } from "next/navigation";

import { DashboardPage } from "@/components/dashboard/dashboard-page";

export default function OrganizationDashboardPage() {
  const { organizationSlug } = useParams<{ organizationSlug: string }>();
  const organizationStatus = useQuery(api.check_membership.hasOrganization);

  return (
    <DashboardPage
      organizationSlug={organizationSlug}
      // Until the status arrives the sections show their loading state, not the locked one.
      pending={organizationStatus === undefined}
      subscriptionLocked={
        organizationStatus !== undefined && organizationStatus.hasActiveSubscription !== true
      }
    />
  );
}
